import axios from "axios";
import { awsUrl, url } from "../../axiosInstance";

export const GetShippingAddress = (userId) => {
  return axios.get(`${awsUrl}/v1/shippingAddress`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const ShippingAddressDelete = (customerId, itemId = null) => {
  return axios.put(
    `${awsUrl}/v1/shippingAddress/active`,
    itemId !== null ? { customerId, Id: itemId } : { customerId },
    {
      headers: {
        Authorization: `Bearer ${localStorage.jwtToken}`,
      },
    },
  );
};

export const ShippingAddressMain = (itemId, userId) => {
  return axios.put(
    `${awsUrl}/v1/customers`,
    { MainAddress: itemId },
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
      },
    },
  );
};

export const ShippingAddressPost = (data) => {
  return axios.post(`${awsUrl}/v1/ShippingAddress`, data, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};
